
import gsap from 'gsap';


if(window.matchMedia("(max-width:830px)").matches) {
   var xPerc = -100
   var  xDist = 0;
   var subMenuDelay = 0.6;
} else {
    var xPerc = 100
    var xDist = 128;
    var subMenuDelay = 0;
}

function mainMenu() {
    var body = document.getElementsByTagName('body');
    var hamburger = document.querySelector('.js-hamburger-menu');
    var menu = document.querySelector('.js-menu-slide');
    var logo = document.querySelector('.top-nav__logo img');
    var logoLink = document.querySelector('[data-name="logo-link"]');
    var visit = document.querySelector('.js-heading-visit');
    hamburger.addEventListener('click', function() {
        if(menu.classList.contains('menu-open')) {
            
            hamburger.classList.remove('hamburger-open');
            closeAllMenus();
            menu.classList.remove('menu-open');
            // menu.style.transform = "translateX(100%)";   
            gsap.to(menu, {
                ease: "power4.out",
                xPercent: 0,
            })
            logo.style.opacity = 1;         
            visit.style.opacity = 1;         
            logoLink.style.pointerEvents = 'all';         
        } else {
            
            hamburger.classList.add('hamburger-open');
            menu.classList.add('menu-open');
            // menu.style.transform = "translateX(0)";
            gsap.to(menu, {
                ease: "power4.out",
                xPercent: -100,
            })
            
            logo.style.opacity = 0;            
            visit.style.opacity = 0;
            logoLink.style.pointerEvents = 'none';         
            openCurrentPage();                
        }
    })

    var mainMenuItems = document.getElementById('main-menu').querySelectorAll(':scope > .menu-item');
    
    function closeAllMenus() {
        mainMenuItems.forEach((menuItem) => {
            if(menuItem.classList.contains('sub-menu-open')) {
                menuItem.classList.remove('sub-menu-open');            
                var subMenu = menuItem.querySelector('.sub-menu-wrap .sub-menu');
                var subMenuItems = subMenu.querySelectorAll('.menu-item');
                gsap.to(subMenuItems, {
                    x: 0,
                    opacity: 0,
                    duration: 0.6,
                    stagger: 0.2,
                    ease: "power3.easeOut"
                });
                
                if(window.matchMedia("(min-width:830px)").matches) {
                    subMenu.style.display = "none";
                }
                gsap.to(subMenu, {
                    xPercent: 0,
                    duration: 0.1
                })
            }
        });
    }
    function openCurrentPage() {
        mainMenuItems.forEach((menuItem) => {
            if(menuItem.classList.contains('current-page-parent')) {
                menuItem.classList.add('sub-menu-open');
                          
                var subMenu = menuItem.querySelector('.sub-menu-wrap .sub-menu');
                if(window.matchMedia("(min-width:830px)").matches) {
                    subMenu.style.display = "block";
                }
                gsap.to(subMenu, {
                    xPercent: xPerc,
                    duration: 0.1
                })
                var subMenuItems = subMenu.querySelectorAll('.menu-item');
                gsap.to(subMenuItems, {
                    x: xDist,
                    opacity: 1,
                    duration: 0.4,
                    stagger: 0.2,
                    ease: "power3.easeOut",
                    delay: subMenuDelay
                })
                var backMenu = menuItem.querySelector('.js-menu-back'); 
                    
                backMenu.addEventListener('click', function(e) {
                
                    gsap.to(subMenu, {
                        xPercent: 0,
                        duration: 0.1
                    })
                })
            }
        })
    
    }
    mainMenuItems.forEach((menuItem) => {
        menuItem.addEventListener('click', function(event) {            
            if(menuItem.classList.contains('menu-item-has-children') && (event.target == menuItem || event.target == menuItem.querySelector(":scope > a"))) {
                event.preventDefault();            
                if(!menuItem.classList.contains('sub-menu-open')) {
                    closeAllMenus();
                    menuItem.classList.add('sub-menu-open');
                            
                    var subMenu = menuItem.querySelector('.sub-menu-wrap .sub-menu');                    
                    if(window.matchMedia("(min-width:830px)").matches) {
                        subMenu.style.display = "block";
                    }
                    gsap.to(subMenu, {
                        xPercent: xPerc,
                        duration: 0.1
                    })
                    var subMenuItems = subMenu.querySelectorAll('.menu-item');
                    gsap.to(subMenuItems, {
                        x: xDist,
                        opacity: 1,
                        duration: 0.4,
                        stagger: 0.2,
                        ease: "power3.easeOut",
                        delay: subMenuDelay
                    })
                    var backMenu = menuItem.querySelector('.js-menu-back'); 
                    
                    backMenu.addEventListener('click', function(e) {
                    
                        gsap.to(subMenu, {
                            xPercent: 0,
                            duration: 0.1
                        })
                    })
                } else {
                    menuItem.classList.remove('sub-menu-open');            
                    var subMenu = menuItem.querySelector('.sub-menu-wrap .sub-menu');
                    var subMenuItems = subMenu.querySelectorAll('.menu-item');
                    const retractTl = gsap.timeline();
                    retractTl.to(subMenuItems, {
                        x: 0,
                        opacity: 0,
                        duration: 0.6,
                        stagger: 0.2,
                        ease: "power3.easeOut"
                    })               
                    retractTl.to(subMenu, {
                        xPercent: 0,
                        duration: 0.1,
                        onComplete: function() {
                            if(window.matchMedia("(min-width:830px)").matches) {
                                subMenu.style.display = "none";
                            }
                        }
                    }, ">")
                    
                }                        
            }            
        })

        
    });
    
}

export default mainMenu;